var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoreturn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_239",
    "data-name": "Group 239",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.229,
    height: 75.197,
    viewBox: "0 0 75.229 75.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "return",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M56.65,9.078l-1.669,1.681-2.492,2.492L50.831,14.9l-2.9-8.721Z",
    transform: "translate(8.408 1.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M44.577,17.985l4.7,4.713h-14.1L34,17.985Z",
    transform: "translate(5.965 3.142)",
    fill: "#94c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M40,37.995h3.526v3.526H40Z",
    transform: "translate(7.017 6.65)",
    fill: "#94c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M34,37.995h3.526v3.526H34Z",
    transform: "translate(5.965 6.65)",
    fill: "#94c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M34.879,17.985,36.055,22.7H28.979l1.2-4.713Z",
    transform: "translate(5.085 3.142)",
    fill: "#d7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M32.5,26.7,29,27.872V21.995h7.052v5.877Z",
    transform: "translate(5.088 3.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M32.279,17.985,31.08,22.7H17l4.7-4.713Z",
    transform: "translate(2.984 3.142)",
    fill: "#94c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M31.1,21.995v5.877L34.6,26.7l3.551,1.175V21.995h14.1V49.028H17V22h14.08ZM47.558,44.327V40.8H44.032v3.526Zm-7.052,0V40.8H36.98v3.526Z",
    transform: "translate(2.984 3.845)",
    fill: "#d7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M59.374,61.6a36.451,36.451,0,0,1-35.2,9.438l.012-.025a1.765,1.765,0,0,1,.917-3.41v.025A32.912,32.912,0,0,0,56.882,12.566l2.492-2.492A36.452,36.452,0,0,1,59.374,61.6Z",
    transform: "translate(4.015 1.755)",
    fill: "#d7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M10.33,54.544v-.012L12.82,52.04l1.647-1.645,2.915,8.733L8.648,56.213Z",
    transform: "translate(1.52 8.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M11.672,11.677A36.392,36.392,0,0,1,46.85,2.239v.012a1.764,1.764,0,0,1-.905,3.41V5.637A32.915,32.915,0,0,0,14.163,60.7l-2.491,2.492a36.413,36.413,0,0,1,0-51.517Z",
    transform: "translate(0.178 0.164)",
    fill: "#d7e9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M11.843,64.553a1.172,1.172,0,0,1-.831-.344,37.613,37.613,0,0,1,0-53.19A37.743,37.743,0,0,1,47.344,1.279a1.175,1.175,0,0,1-.606,2.271,35.391,35.391,0,0,0-34.063,9.13,35.264,35.264,0,0,0,0,49.867,1.175,1.175,0,0,1-.831,2.006Z",
    transform: "translate(0.003 -0.01)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M13.808,61.534a1.172,1.172,0,0,1-.831-.344A34.088,34.088,0,0,1,45.891,4.157a1.175,1.175,0,0,1-.606,2.271,31.738,31.738,0,0,0-30.646,53.1,1.175,1.175,0,0,1-.831,2.006Z",
    transform: "translate(0.531 0.516)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M17.553,59.611a1.176,1.176,0,0,1-.371-.061L8.454,56.64A1.175,1.175,0,1,1,9.2,54.41l8.728,2.91a1.176,1.176,0,0,1-.373,2.291Z",
    transform: "translate(1.345 9.518)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M16.685,60.479a1.174,1.174,0,0,1-1.114-.8l-2.91-8.727a1.175,1.175,0,0,1,2.23-.744l2.91,8.727a1.174,1.174,0,0,1-.743,1.487,1.151,1.151,0,0,1-.373.061Z",
    transform: "translate(2.213 8.65)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M8.825,57.57a1.175,1.175,0,0,1-.831-2.006l5.818-5.817a1.175,1.175,0,0,1,1.662,1.662L9.656,57.225A1.172,1.172,0,0,1,8.825,57.57Z",
    transform: "translate(1.345 8.651)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M39.868,6.888a2.922,2.922,0,0,1-.764-.1,1.175,1.175,0,1,1,.606-2.271.587.587,0,0,0,.449-.059.57.57,0,0,0,.27-.353.585.585,0,0,0-.413-.723,1.175,1.175,0,1,1,.606-2.271,2.938,2.938,0,0,1-.756,5.777Z",
    transform: "translate(6.707 0.176)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M33.522,73.618a37.475,37.475,0,0,1-9.672-1.267,1.175,1.175,0,0,1,.606-2.271,35.4,35.4,0,0,0,34.063-9.131,35.264,35.264,0,0,0,0-49.867A1.175,1.175,0,0,1,60.181,9.42a37.613,37.613,0,0,1,0,53.19A37.746,37.746,0,0,1,33.522,73.618Z",
    transform: "translate(4.033 1.579)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M33.391,69.72a33.948,33.948,0,0,1-8.755-1.146,1.175,1.175,0,1,1,.606-2.271A31.738,31.738,0,0,0,55.889,13.2a1.175,1.175,0,1,1,1.662-1.662A34.076,34.076,0,0,1,33.391,69.72Z",
    transform: "translate(4.17 1.951)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M56.828,10.434a1.176,1.176,0,0,1-.371-.061L47.729,7.464a1.175,1.175,0,0,1,.744-2.23L57.2,8.143a1.176,1.176,0,0,1-.373,2.291Z",
    transform: "translate(8.232 0.895)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M51.009,16.253a1.174,1.174,0,0,1-1.114-.8l-2.91-8.727a1.175,1.175,0,1,1,2.23-.744l2.91,8.727a1.177,1.177,0,0,1-1.115,1.548Z",
    transform: "translate(8.232 0.895)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M50.575,15.819a1.175,1.175,0,0,1-.831-2.006l5.818-5.818a1.175,1.175,0,0,1,1.662,1.662l-5.818,5.818A1.172,1.172,0,0,1,50.575,15.819Z",
    transform: "translate(8.666 1.329)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M24.364,63.8a1.184,1.184,0,0,1-.3-.04,2.938,2.938,0,1,1,1.519-5.677,1.176,1.176,0,0,1-.6,2.273.586.586,0,0,0-.722.413.578.578,0,0,0,.058.45.585.585,0,0,0,.356.271,1.175,1.175,0,0,1-.3,2.31Z",
    transform: "translate(3.84 10.155)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M52.431,50.385H17.17a1.174,1.174,0,0,1-1.175-1.175V22.17A1.174,1.174,0,0,1,17.17,21h35.26a1.174,1.174,0,0,1,1.175,1.175V49.209A1.174,1.174,0,0,1,52.431,50.385ZM18.346,48.034h32.91V23.346H18.346Z",
    transform: "translate(2.808 3.669)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M17.17,24.048a1.175,1.175,0,0,1-.831-2.006l4.7-4.7A1.175,1.175,0,1,1,22.7,19L18,23.7A1.172,1.172,0,0,1,17.17,24.048Z",
    transform: "translate(2.808 2.968)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M47.872,24.048a1.172,1.172,0,0,1-.831-.344l-4.7-4.7A1.175,1.175,0,0,1,44,17.336l4.7,4.7a1.175,1.175,0,0,1-.831,2.006Z",
    transform: "translate(7.367 2.968)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M47.026,19.343H21.171a1.175,1.175,0,0,1,0-2.351H47.026a1.175,1.175,0,0,1,0,2.351Z",
    transform: "translate(3.51 2.968)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M29.155,24.048a1.176,1.176,0,0,1-1.14-1.464l1.2-4.7a1.175,1.175,0,0,1,2.278.578l-1.2,4.7A1.173,1.173,0,0,1,29.155,24.048Z",
    transform: "translate(4.909 2.967)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M35.346,24.048a1.175,1.175,0,0,1-1.139-.891l-1.175-4.7a1.175,1.175,0,1,1,2.28-.569l1.175,4.7a1.173,1.173,0,0,1-.856,1.425A1.194,1.194,0,0,1,35.346,24.048Z",
    transform: "translate(5.789 2.967)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M29.17,29.229a1.174,1.174,0,0,1-1.175-1.175V22.17a1.175,1.175,0,1,1,2.351,0v5.884A1.174,1.174,0,0,1,29.17,29.229Z",
    transform: "translate(4.912 3.669)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M29.174,28.527a1.176,1.176,0,0,1-.374-2.291l3.5-1.175a1.184,1.184,0,0,1,.744,0l3.546,1.175a1.176,1.176,0,0,1-.739,2.232L32.68,27.414l-3.131,1.052a1.2,1.2,0,0,1-.375.061Z",
    transform: "translate(4.913 4.372)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M35.171,29.229A1.174,1.174,0,0,1,34,28.054V22.17a1.175,1.175,0,1,1,2.351,0v5.884A1.174,1.174,0,0,1,35.171,29.229Z",
    transform: "translate(5.965 3.669)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M30.574,39.35h-9.4a1.175,1.175,0,0,1,0-2.351h9.4a1.175,1.175,0,0,1,0,2.351Z",
    transform: "translate(3.51 6.476)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M25.873,42.35h-4.7a1.175,1.175,0,0,1,0-2.351h4.7a1.175,1.175,0,0,1,0,2.351Z",
    transform: "translate(3.51 7.002)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M37.7,42.876H34.169A1.174,1.174,0,0,1,32.994,41.7V38.174A1.174,1.174,0,0,1,34.169,37H37.7a1.174,1.174,0,0,1,1.175,1.175V41.7A1.174,1.174,0,0,1,37.7,42.876Zm-2.351-2.351H36.52V39.35H35.345Z",
    transform: "translate(5.789 6.476)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M43.7,42.876H40.175A1.174,1.174,0,0,1,39,41.7V38.174A1.174,1.174,0,0,1,40.175,37H43.7a1.174,1.174,0,0,1,1.175,1.175V41.7A1.174,1.174,0,0,1,43.7,42.876Zm-2.351-2.351h1.175V39.35H41.351Z",
    transform: "translate(6.842 6.476)",
    fill: "#002173"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10584",
    "data-name": "Rectangle 10584",
    width: 73.405,
    height: 4.736,
    transform: "translate(7.835 17.221) rotate(30)",
    fill: "#002173"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoreturn);
export default __webpack_public_path__ + "static/media/noreturn.86e4f6a524479cc57709765eab727c5d.svg";
export { ForwardRef as ReactComponent };